import { MouseEventHandler, useEffect, useState } from 'react';
import { renderHTML } from '../../Utils';
import { SitePage } from '../../Models/SitePage';
import SitePageApi from '../../Api/SitePageApi';
import Loader from '../Common/Loader';
import { PageType } from '../../Enums/PageType';
import terrMap from '../../Assets/terr20211008.png';
import $ from 'jquery';
import { FaSquareFacebook, FaSquareYoutube } from 'react-icons/fa6';

export default function AboutUs() {
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getSitePage();
  }, []);
  const getSitePage = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageByPageType(PageType.AboutUs.toString())
        .then((res) => {
          setPageData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  const handleHighlight = (
    name: string,
    e: React.MouseEvent<HTMLAreaElement, MouseEvent>
  ) => {
    e.preventDefault();
    highlight(name);
  };
  function highlight(name: string) {
    $('.salesperson').css('background-color', 'white');
    $('#' + name).css('background-color', '#e0e0e0');
  }
  return (
    <>
      {isLoading && <Loader />}
      <title>{pageData?.title}</title>
      {/* <metadata>{pageData?.metaData}</metadata> */}
      <div className='w-full xl:w-1/2 p-5 mx-auto'>
        <h5 className='text-gray-900 font-bold text-4xl mb-4'>
          {pageData?.header}
        </h5>
        <div className='text-justify mb-10'>
          {pageData?.description && renderHTML(pageData?.description)}
        </div>
        <div className='sm:flex justify-center gap-5 mb-10'>
          <div className='m-auto'>
            <img src={terrMap} useMap='#Map' />
          </div>
          <div className='m-auto'>
            <div
              className='salesperson p-2 mb-2 border-l-8 rounded-lg border-l-[#90b082]'
              id='west'
            >
              <strong>Kevin Mooney</strong>
              <br />
              <em>316-640-5867</em>
              <br />
              <a href='mailto:kmooney@pricebroseq.com' className='text-[#00F]'>
                kmooney@pricebroseq.com
              </a>
              <br />
            </div>
            <div
              className='salesperson p-2 mb-2 border-l-8 rounded-lg border-l-[#7d2d3b]'
              id='central'
            >
              <strong>Andrew Shinkle</strong>
              <br />
              <em>316-213-0060</em>
              <br />
              <a href='mailto:ashinkle@pricebroseq.com' className='text-[#00F]'>
                ashinkle@pricebroseq.com
              </a>
              <br />
            </div>
            <div
              className='salesperson p-2 mb-2 border-l-8 rounded-lg border-l-[#dfda64]'
              id='east'
            >
              <strong>Justin Thomas</strong>
              <br />
              316-650-4842
              <br />
              <a href='mailto:jthomas@pricebroseq.com' className='text-[#00F]'>
                jthomas@pricebroseq.com
              </a>
              <br />
            </div>

            <div
              className='salesperson p-2 mb-2 border-l-8 rounded-lg border-l-[#627783]'
              id='northcentral'
            >
              <strong>Kevin Allan</strong>
              <br />
              316-706-0691
              <br />
              <a href='mailto:kallan@pricebroseq.com' className='text-[#00F]'>
                kallan@pricebroseq.com
              </a>
              <br />
            </div>
            <map name='Map'>
              <area
                id='central'
                onMouseOver={(e) => handleHighlight('central', e)}
                href='#'
                coords='171,129,214,126,220,187,174,185'
                shape='poly'
              />
              <area
                onMouseOver={(e) => handleHighlight('west', e)}
                href='#'
                coords='14,52,63,56,82,56,84,18,147,22,148,55,154,56,154,63,149,63,147,75,157,74,160,107,169,108,167,119,168,128,172,129,173,143,171,144,172,171,174,186,167,186,155,182,146,176,138,174,136,139,94,139,93,128,8,126'
                shape='poly'
              />
              <area
                onMouseOver={(e) => handleHighlight('northcentral', e)}
                href='#'
                coords='158,74,188,74,201,73,194,62,220,62,221,67,226,67,227,71,233,71,234,76,237,79,237,84,243,84,245,87,252,87,253,102,256,104,246,105,243,105,241,102,233,103,234,105,229,105,220,104,220,99,212,100,212,102,202,102,200,100,194,101,194,105,188,106,185,108,177,108,177,120,168,121,167,113,170,107,159,108'
                shape='poly'
              />
              <area
                onMouseOver={(e) => handleHighlight('central', e)}
                href='#'
                coords='168,120,177,121,177,110,185,109,193,106,193,103,200,102,212,102,212,100,221,100,221,103,228,105,226,107,231,106,233,104,240,103,242,106,250,105,254,103,255,108,261,112,259,113,264,120,261,122,264,125,264,132,214,137,218,156,219,187,214,187,208,182,205,185,202,183,199,185,195,185,194,189,183,184,181,189,175,185,173,174,171,171,171,145,174,144,174,129,168,129'
                shape='poly'
              />
              <area
                onMouseOver={(e) => handleHighlight('east', e)}
                href='#'
                coords='221,8,250,6,254,10,251,16,255,20,259,22,262,23,297,19,297,24,303,31,308,73,307,76,311,82,310,89,306,95,305,102,304,105,306,108,304,111,300,112,302,118,295,117,290,120,291,125,290,128,287,128,287,133,286,139,277,139,279,133,278,130,264,132,264,126,261,122,264,120,261,114,259,114,262,110,259,109,256,109,255,102,253,102,252,87,246,87,245,84,240,84,236,83,237,78,234,76,233,72,227,72,226,69,221,68,222,62,218,61,217,51,222,50,220,44,219,40,220,36,218,31,222,30'
                shape='poly'
              />

              <area
                onMouseOver={(e) => handleHighlight('northcentral', e)}
                href='#'
                coords='148,19,150,53,155,62,148,63,149,74,203,72,197,63,188,40,185,27,174,23'
                shape='poly'
              />
              <area
                onMouseOver={(e) => handleHighlight('east', e)}
                href='#'
                coords='180,10,250,6,253,17,260,22,266,30,263,38,256,42,258,50,253,57,253,63,249,58,198,63'
                shape='poly'
              />
            </map>
          </div>
        </div>
        <div className='sm:flex justify-left gap-5'>
          <div className='text-xl'>
            <div className='items-center space-x-2 font-bold text-gray-500 leading-8'>
              Agriculture Distribution Division
            </div>
            <div className='p-2 mb-2'>
              <strong>Trey Price</strong>
              <br />
              <em>877-957-9577</em>
              <br />
              <a href='mailto:tprice@pricebroseq.com' className='text-[#00F]'>
                tprice@pricebroseq.com
              </a>
              <br />
            </div>
          </div>
          <div className='flex justify-center m-auto gap-5'>
            <div>
              <FaSquareFacebook
                className='cursor-pointer'
                size={75}
                color='#1877F2'
                onClick={() =>
                  window.open(
                    'https://www.facebook.com/PriceBrosEqAG/',
                    '_blank'
                  )
                }
              />
            </div>
            <div>
              <FaSquareYoutube
                className='cursor-pointer'
                size={75}
                color='#FF0000'
                onClick={() =>
                  window.open(
                    'https://www.youtube.com/PriceBrosEqAG/',
                    '_blank'
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
